import apiClient from '../api'

/**
 * Create a new deposit plan with optional loan usage
 * @param {string} walletType - Wallet type (e.g., 'usdt-main')
 * @param {string|number} amount - Total deposit amount
 * @param {number} durationDays - Duration in days
 * @param {boolean} useLoan - Whether to use loan for this deposit
 * @param {number} loanId - Loan ID to use (required if useLoan is true)
 * @param {string|number} loanAmount - Loan amount to use (optional, defaults to full loan amount)
 * @returns {Promise} Created deposit plan
 */
export const createDepositWithLoan = (walletType, amount, durationDays, useLoan = false, loanId = null, loanAmount = null) => {
  const payload = {
    wallet_type: walletType,
    amount: amount.toString(),
    duration_days: durationDays
  }
  
  if (useLoan && loanId) {
    payload.use_loan = true
    payload.loan_id = loanId
    if (loanAmount !== null && loanAmount !== undefined) {
      payload.loan_amount = loanAmount.toString()
    }
  }
  
  return apiClient.post('/deposit-plans/create', payload)
}

/**
 * Calculate interest for deposit with loan consideration
 * @param {string|number} amount - Total deposit amount
 * @param {number} durationDays - Duration in days
 * @param {number} loanAmount - Loan amount used (optional)
 * @returns {Promise} Calculated interest details
 */
export const calculateInterestWithLoan = (amount, durationDays, loanAmount = null) => {
  const payload = {
    amount: amount.toString(),
    duration_days: durationDays
  }
  
  if (loanAmount !== null && loanAmount !== undefined) {
    payload.loan_amount = loanAmount.toString()
  }
  
  return apiClient.post('/deposit-plans/calculate', payload)
}

